<template>
  <svg
    :class="customStyle"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z"
      stroke="#C14B3A"
    />
    <path
      d="M12.6938 11.9999L16.2094 7.80924C16.2683 7.73959 16.2188 7.63379 16.1277 7.63379H15.059C14.996 7.63379 14.9358 7.66191 14.8942 7.71013L11.9947 11.1668L9.09513 7.71013C9.05495 7.66191 8.99468 7.63379 8.93039 7.63379H7.86164C7.77057 7.63379 7.72102 7.73959 7.77995 7.80924L11.2956 11.9999L7.77995 16.1905C7.76675 16.206 7.75828 16.225 7.75555 16.2452C7.75282 16.2654 7.75594 16.2859 7.76454 16.3044C7.77314 16.3229 7.78686 16.3385 7.80407 16.3494C7.82129 16.3603 7.84127 16.366 7.86164 16.3659H8.93039C8.99334 16.3659 9.05361 16.3378 9.09513 16.2896L11.9947 12.8329L14.8942 16.2896C14.9344 16.3378 14.9947 16.3659 15.059 16.3659H16.1277C16.2188 16.3659 16.2683 16.2601 16.2094 16.1905L12.6938 11.9999Z"
      fill="#C14B3A"
    />
  </svg>
</template>

<script>
export default {
  name: 'CrossRedIcon',

  props: {
    customStyle: {
      type: String,
      default: 'h-4 w-4',
    },
  },
}
</script>
